module.exports = __webpack_public_path__ + "img/icone-agro.5e2a8c77.svg";